import api from "./BaseAPI.js";
import Http from "./Http.js";
import * as APPCONFIG from "../config/app-config.js";

class YouTubeService {


  getVideoDetails(videoId) {
    return api({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}auth/youtube/video/${videoId}`,
    });
  }
}

export default new YouTubeService();